/**
 * This js file should  be loaded as javascript file if the user isn't logged in.
 * We'll load jQuery, Tether and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs.
 */

window.Tether = require('tether');

window.$ = window.jQuery = require('jquery');

require('bootstrap');



// WEBPACK FOOTER //
// ./resources/assets/js/login.js